export var opening = {
    date: "2024-07-26",
    time: "14:15",
    address: "Stade de France, Saint-Denis"
}

export var basketball = {
    date: "2024-08-02",
    time: "11:30",
    address: "Palais omnisports Paris-Bercy"
}

export var aviron = {
    date: "2024-07-30",
    time: "10:15",
    address: "Stade Nautique, Vaires-sur-Marne"
}


export var closing = {
    date: "2024-08-11",
    time: "21:00",
    address: "Stade de France, Saint-Denis"
}